import type { TruncationMode } from '@dynatrace/strato-components/typography';

/**
 * @internal
 */
export const truncateText = (
  text: string,
  truncationMode: TruncationMode,
  stopTruncation: (text: string) => boolean,
) => {
  let truncatedText = text;

  while (!stopTruncation(truncatedText)) {
    const filteredText = truncatedText.replace(/\.\.\./, '');

    if (!filteredText.length) {
      break;
    }

    truncatedText = TRUNCATE_LABEL[truncationMode](filteredText);
  }

  return truncatedText;
};

export const ELLIPSIS = '...';

export const middleTruncation = (text: string) => {
  const middle = Math.floor(text.length / 2);
  const firstHalf = text.slice(0, middle);
  const secondHalf = text.slice(middle + 1);

  const hasEllipsis = firstHalf.length || secondHalf.length;

  const newText = `${firstHalf}${hasEllipsis ? ELLIPSIS : ''}${secondHalf}`;

  return newText;
};

export const startTruncation = (text: string) => {
  const slicedText = text.slice(1);
  const hasEllipsis = slicedText.length;

  const newText = `${hasEllipsis ? ELLIPSIS : ''}${slicedText}`;

  return newText;
};

export const endTruncation = (text: string) => {
  const slicedText = text.slice(0, -1);
  const hasEllipsis = slicedText.length;

  const newText = `${text.slice(0, -1)}${hasEllipsis ? ELLIPSIS : ''}`;

  return newText;
};

export const TRUNCATE_LABEL: Record<TruncationMode, (text: string) => string> =
  {
    start: startTruncation,
    end: endTruncation,
    middle: middleTruncation,
  };
